import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';

@Injectable({
	providedIn: 'root'
})
export class StripeService {

	constructor(
		private http: HttpClient
	) { }

	getStripeBillingPortalLink(companyId: string) {
		let headers = new HttpHeaders();
		headers = headers.set('Content-Type', 'text/plain');

		let params = new HttpParams();
		params = params.set('companyId', companyId);

		const requestUrl = `${environment.serviceUrl}/billing/portal/link`;

		return this.http.get(requestUrl, { headers, params, responseType: 'text' });
	}

	acceptStripeQuote(customerId: string, quoteId: string) {
		let headers = new HttpHeaders();
		headers = headers.set('Content-Type', 'application/pdf');

		let params = new HttpParams();
		params = params.set('customerId', customerId);
		params = params.set('quoteId', quoteId);

		const requestUrl = `${environment.serviceUrl}/billing/quote/accept`;

		return this.http.post<any>(requestUrl, '', { headers, params });
	}

	cancelStripeQuote(customerId: string, quoteId: string) {
		let headers = new HttpHeaders();
		headers = headers.set('Content-Type', 'application/json');

		let params = new HttpParams();
		params = params.set('customerId', customerId);
		params = params.set('quoteId', quoteId);

		const requestUrl = `${environment.serviceUrl}/billing/quote`;

		return this.http.delete<boolean>(requestUrl, { headers, params });
	}

	createStripeQuote(customerId: string, priceId: string, units: number, subscriptionType: string, billingType: string, usageType: string) {
		let headers = new HttpHeaders();
		headers = headers.set('Content-Type', 'application/json');

		let params = new HttpParams();
		params = params.set('customerId', customerId);
		params = params.set('priceId', priceId);
		params = params.set('units', units);
		params = params.set('subscriptionType', subscriptionType);
		params = params.set('billingType', billingType);
		params = params.set('usageType', usageType);

		const requestUrl = `${environment.serviceUrl}/billing/quote`;

		return this.http.post<any>(requestUrl, '', { headers, params });
	}


	getStripeInvoiceDownloadLink(customerId: string, subscriptionId: string) {
		let headers = new HttpHeaders();
		headers = headers.set('Content-Type', 'application/pdf');

		let params = new HttpParams();
		params = params.set('customerId', customerId);
		params = params.set('subscriptionId', subscriptionId);

		const requestUrl = `${environment.serviceUrl}/billing/invoice/download/link`;

		return this.http.get<any>(requestUrl, { headers, params });
	}

	getStripeQuoteDownloadStream(customerId: string, quoteId: string) {
		let headers = new HttpHeaders();
		headers = headers.set('Content-Type', 'application/pdf');

		let params = new HttpParams();
		params = params.set('customerId', customerId);
		params = params.set('quoteId', quoteId);

		const requestUrl = `${environment.serviceUrl}/billing/quote/download/stream`;

		return this.http.get(requestUrl, { headers, params, responseType: 'blob' });
	}

	getStripeQuotes(customerId: string) {
		let headers = new HttpHeaders();
		headers = headers.set('Content-Type', 'application/json');

		let params = new HttpParams();
		params = params.set('customerId', customerId);

		const requestUrl = `${environment.serviceUrl}/billing/quotes`;

		return this.http.get<any>(requestUrl, { headers, params });
	}

	getCurrentStripeSubscription(customerId: string) {
		let headers = new HttpHeaders();
		headers = headers.set('Content-Type', 'application/json');

		let params = new HttpParams();
		params = params.set('customerId', customerId);

		const requestUrl = `${environment.serviceUrl}/billing/subscription`;

		return this.http.get<any>(requestUrl, { headers, params });
	}

	getStripePrice(priceId: string, units: number) {
		let headers = new HttpHeaders();
		headers = headers.set('Content-Type', 'application/json');

		let params = new HttpParams();
		params = params.set('priceId', priceId);
		params = params.set('units', units);

		const requestUrl = `${environment.serviceUrl}/billing/price`;

		return this.http.get<any>(requestUrl, { headers, params });
	}
}
